<template>
  <Layout>
    <div class="is-flex">
      <Card class="w-full">
        <template slot="header">
          <div class>
            <h3 class="is-size-4 has-text-weight-bold">Crear Producto</h3>
          </div>
        </template>
        <template slot="content">
          <section>
            <b-tabs v-model="activeTab" :animated="false">
              <b-tab-item>
                <template #header>
                  <span>Información</span>
                </template>
                <div class>
                  <h2 class="my-3">Categorías</h2>
                  <div class="scroll-container">
                    <template v-if="categories.length > 0">
                      <div
                        class="field"
                        v-for="c in categories"
                        :key="c.name + c.id"
                      >
                        <b-checkbox
                          :id="'c_' + c.id"
                          :native-value="c.id"
                          v-model="data.category"
                          >{{ c.name }}</b-checkbox
                        >
                      </div>
                    </template>
                    <template v-else>
                      <p>No hay categorías</p>
                    </template>
                  </div>
                  <hr />
                  <h2 class="my-3">Local</h2>
                  <div class="scroll-container">
                    <template v-if="locals.length > 0">
                      <div
                        class="field"
                        v-for="l in locals"
                        :key="l.name + l.id"
                      >
                        <b-checkbox
                          :id="'l_' + l.id"
                          :native-value="l.id"
                          v-model="data.local"
                          >{{ l.name }}</b-checkbox
                        >
                      </div>
                    </template>
                    <template v-else>
                      <p>No hay locales</p>
                    </template>
                  </div>
                  <hr />
                  <b-field label="Activo">
                    <b-switch
                      v-model="data.is_active"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field label="Es Oculto">
                    <b-switch
                      v-model="data.is_hidden"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field
                    label="Tipo de producto"
                    :custom-class="
                      $v.data.type_product.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.type_product.$error }"
                  >
                    <b-select
                      placeholder="Seleccione"
                      expanded
                      v-model="data.type_product"
                    >
                      <option
                        v-for="type_product in type_products"
                        :value="type_product.value"
                        :key="type_product.value"
                      >
                        {{ type_product.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    label="Nombre"
                    :custom-class="$v.data.name.$error ? 'has-text-danger' : ''"
                    :type="{ 'is-danger': $v.data.name.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.name.required && $v.data.name.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.name"></b-input>
                  </b-field>
                  <b-field
                    label="Descripción"
                    :custom-class="
                      $v.data.description.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.description.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.description.required &&
                          $v.data.description.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.description"></b-input>
                  </b-field>
                  <b-field
                    label="Precio"
                    :custom-class="
                      $v.data.price.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.price.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.price.required && $v.data.price.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.price"></b-input>
                  </b-field>
                  <b-field label="Tiene Stock">
                    <b-switch
                      v-model="data.has_stock"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field
                    label="Stock"
                    v-if="data.has_stock"
                    :custom-class="
                      $v.data.stock.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.stock.$error }"
                    :message="[{ 'Campo requerido': !$v.data.stock.required }]"
                  >
                    <b-input v-model="data.stock" type="number"></b-input>
                  </b-field>
                  <b-field label="Imagen">
                    <upload
                      :image="data.image"
                      @change="uploadFileImage"
                    ></upload>
                  </b-field>
                </div>
              </b-tab-item>
              <b-tab-item>
                <template #header>
                  <span>Caracterísitcas</span>
                </template>
                <div>
                  <b-field label="Tamaño">
                    <b-select
                      placeholder="Seleccione una opción"
                      v-model="data.size"
                      expanded
                      class="selectForm"
                    >
                      <option value="XS">Muy pequeño (XS)</option>
                      <option value="S">Pequeño (S)</option>
                      <option value="M">Mediano (M)</option>
                      <option value="L">Grande (L)</option>
                    </b-select>
                    <!--  -->
                  </b-field>
                  <b-field label="Unidad" class="unity">
                    <small>Paquete, Bolsa, etc. </small>
                    <b-input v-model="data.unity"></b-input>
                  </b-field>
                  <!-- <b-field
                    label="Peso"
                    :custom-class="
                      $v.data.weight.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.weight.$error }"
                    :message="[
                      { 'Formato incorrecto': !$v.data.weight.decimal && $v.data.weight.$error}
                    ]"
                  >
                    <b-input v-model="data.weight"></b-input>
                  </b-field> -->
                  <b-field
                    label="Peso"
                    :custom-class="
                      $v.data.volumen.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.volumen.$error }"
                    :message="[
                      {
                        'Formato incorrecto':
                          !$v.data.volumen.decimal && $v.data.volumen.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.volumen"></b-input>
                  </b-field>
                  <b-field label="Características">
                    <vue-editor
                      v-model="data.features"
                      :editorToolbar="customToolbar"
                    >
                    </vue-editor>
                  </b-field>
                  <b-field label="Especificaciones" class="doubleInput">
                    <div
                      class="doubleInput__container"
                      v-for="(s, index) in data.specs"
                      :key="index"
                    >
                      <b-field label="Nombre">
                        <b-input v-model="s.name"></b-input>
                      </b-field>
                      <b-field label="Descripción">
                        <b-input v-model="s.value"></b-input>
                      </b-field>
                      <div class="dobleInput__delete">
                        <b-button
                          type="is-danger"
                          size="is-small"
                          @click="delSpecs(index)"
                        >
                          <font-awesome-icon :icon="['fas', 'trash']" />
                        </b-button>
                      </div>
                      <br />
                    </div>
                    <b-button
                      type="is-primary"
                      size="is-small"
                      @click="addSpecs"
                    >
                      Agregar <font-awesome-icon :icon="['fas', 'plus']" />
                    </b-button>
                  </b-field>
                </div>
              </b-tab-item>
            </b-tabs>
          </section>
        </template>
      </Card>
      <Aside>
        <Button
          variant="main"
          :spinner="loading"
          @click.native="postInfo($event)"
          block
          >Guardar</Button
        >
        <Button
          tag="router-link"
          :to="{ name: 'product_list' }"
          variant="gray"
          block
          class="mt-2"
          >Cancelar</Button
        >
      </Aside>
    </div>
  </Layout>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { required, decimal } from 'vuelidate/lib/validators'
import Layout from '@/components/Layout'
import Card from '@/components/base/Card'
import Aside from '@/components/Aside'
import Button from '@/components/form/Button'
import Errors from '@/mixins/error'
import Upload from '@/components/base/Upload'
import ProductService from '@/services/ProductService'
import { TYPE_PRODUCT } from '@/constants'

export default {
  name: 'ProductCreate',
  components: {
    Layout,
    Card,
    Aside,
    Button,
    Upload,
    VueEditor
  },
  mixins: [Errors],
  data() {
    return {
      type_products: TYPE_PRODUCT,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link', 'image', 'video'],
        ['clean'] // remove formatting button
      ],
      activeTab: 0,
      loading: false,
      items: [
        {
          text: 'Categoría Listado',
          href: '/'
        },
        {
          text: 'Categoría Crear',
          active: true
        }
      ],
      data: {
        local: [],
        name: '',
        category: [],
        price: null,
        stock: 0,
        has_stock: false,
        description: '',
        image: '',
        position: 1,
        is_active: true,
        title: '',
        meta_description: '',
        route_image: '',
        tags: [],
        size: null,
        unity: null,
        volumen: null,
        weight: null,
        specs: [],
        features: '',
        type_product: '',
        is_hidden: false
      },
      formData: new FormData(),
      url_delete: '',
      categories: [],
      locals: [],
      loading_locals: null
    }
  },
  validations: {
    data: {
      name: { required },
      description: { required },
      price: { required, decimal },
      stock: { required },
      weight: { decimal },
      volumen: { decimal },
      type_product: { required }
    }
  },
  created() {
    this.getCategories()
    this.getLocals()
  },
  methods: {
    addSpecs() {
      if (this.data.specs.length > 0) {
        const item = this.data.specs.length - 1
        if (
          this.data.specs[item].name !== '' &&
          this.data.specs[item].value !== ''
        ) {
          this.data.specs.push({ name: '', value: '' })
        }
      } else {
        this.data.specs.push({ name: '', value: '' })
      }
    },
    delSpecs(index) {
      this.data.specs.splice(index, 1)
    },
    async postInfo() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.data.weight = this.data.volumen
        try {
          const response = await ProductService.postNew(this.data)
          this.loading = false
          const productId = response.data.id
          if (this.data.route_image) {
            await ProductService.putImage(productId, this.formData)
            this.$router.push({ name: 'product_list' })
          } else {
            this.$router.push({ name: 'product_list' })
          }
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'S',
            msg: 'Se guardó correctamente.'
          })
        } catch (error) {
          this.loading = false
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'D',
            msg: 'Ocurrió un error.'
          })
        }
      }
    },
    uploadFileImage(file) {
      if (file) {
        this.formData.append('image', file)
        this.data.route_image = file
      }
    },
    async getCategories() {
      const response = await ProductService.getListCategory()
      this.categories = response.data
    },
    async getLocals() {
      const response = await ProductService.getListLocal()
      this.locals = response.data
    }
  }
}
</script>
